/* Group existing policy HTML by its headings without changing its wording. */
(() => {
 const body=document.querySelector('.shopify-policy__body');if(!body)return;
 const headings=[...body.children].filter(el=>el.matches('h2,h3'));
 if(headings.length<2)return;
 headings.forEach((heading,index)=>{
  const details=document.createElement('details'),summary=document.createElement('summary');
  details.className='tf-policy-details';details.open=index===0;
  summary.append(...heading.childNodes);details.append(summary);
  let next=heading.nextSibling;
  while(next&&!headings.includes(next)){const node=next;next=next.nextSibling;details.append(node);}
  heading.replaceWith(details);
 });
})();
